<template>
    <div >

        <NickAndAvatar  :text="floor()" :uid="postItem.uid"></NickAndAvatar>

<!--        <van-cell>-->
<!--            <van-image slot="icon" round-->
<!--                       width="25"-->
<!--                       height="25"-->
<!--                       src="https://img.yzcdn.cn/vant/cat.jpeg"-->
<!--            />-->
<!--            <span slot="title" style="display:inline-block;color:#8197b3;font-size: 14px;height: 25px;line-height: 25px;margin-left: 5px">{{postItem.uid}}</span>-->

<!--            <span slot="right-icon" style="color:#8197b3;font-size: 12px "> {{floor()}}</span>-->
<!--        </van-cell>-->

        <div style="padding: 15px;font-size:14px;color: #8197b3"  v-html="postItem.content.replace(/\n/g,'<br>')" @click='contentClick'></div>
        <div v-if="postItem.refPost">
            <div style="padding: 15px 15px 0 30px;font-size:12px;color: #8197b3;">@ <Nick :uid="postItem.refPost.uid"></Nick></div>
            <div style="padding: 0 15px 15px 30px;font-size:12px;color: #8197b3" v-html="refContent(postItem.refPost)" @click="refContentClick"></div>
        </div>

<!--        <div v-if="postItem.lastEditTime" style="padding: 15px;font-size:11px;margin-right: 5px;color: #8197b3;text-align: right" >-->
<!--            已在{{moment(postItem.lastEditTime).fromNow()}}编辑过-->
<!--        </div>-->
        <van-cell>
            <span slot="title" style="display:inline-block;color:#8197b3;font-size: 12px;height: 25px;line-height: 25px;">
                {{moment(postItem.ctime).format("YYYY-MM-DD HH:mm")}}
            </span>

            <span slot="right-icon" style="color:#8197b3;font-size: 12px ">

<!--                <span v-if="postItem.editable" class="wcc-icon wcc-icon-modify" @click="$emit('showEdit',postItem)"-->
<!--                      style="margin-right:5px;font-size:11px;border-radius: 999px;color:#43b292;border: 1px solid #43b292;padding: 0 10px;line-height: 18px;height: 18px"-->
<!--                > 编辑</span>-->

                <span v-if="postItem.deletable" class="wcc-icon wcc-icon-del" @click="delPost"
                      style="margin-right:5px;font-size:11px;border-radius: 999px;color:#43b292;border: 1px solid #43b292;padding: 0 10px;line-height: 18px;height: 18px"
                > 删除</span>

                <span class="wcc-icon wcc-icon-agree" @click="setAgree"
                      style="margin-right:5px;font-size:11px;border-radius: 999px;color:#43b292;border: 1px solid #43b292;padding: 0 10px;line-height: 18px;height: 18px"
                      :class="postItem.iagree?'agree':''"> {{postItem.agreeCount}}</span>

                <span  class="wcc-icon wcc-icon-post" @click="addPost"
                      style="font-size:11px;border-radius: 999px;color:#43b292;border: 1px solid #43b292;padding: 0 10px;line-height: 18px;height: 18px"
                > {{postItem.postCount}}</span>

<!--                    <van-button v-if="postItem.editable" @click="$emit('showEdit',postItem)"-->
<!--                                plain type="default" size="small" round icon="edit"-->
<!--                                style="margin-right: 5px">-->
<!--                    </van-button>-->
<!--                    <van-button v-if="postItem.deletable" @click="delPost"-->
<!--                                plain type="default" size="small" round icon="delete"-->
<!--                                style="margin-right: 5px">-->
<!--                    </van-button>-->

<!--                    <van-button plain type="default" size="small" round icon="comment-o"-->
<!--                                style="margin-right: 5px"-->
<!--                                @click="addPost">-->
<!--                        {{postItem.postCount}}-->
<!--                    </van-button>-->

<!--                    <van-button plain type="default" size="small" round icon="good-job-o"-->
<!--                                :class="postItem.iagree?'agree':''"-->
<!--                                @click="setAgree">{{postItem.agreeCount}}-->
<!--                    </van-button>-->
            </span>
        </van-cell>


<!--        <van-cell  :title="postItem.uid +'于' + moment(postItem.ctime).fromNow()" icon="location-o"-->
<!--                  :value="postItem.title"   >-->
<!--            <div slot="label">-->
<!--                <div v-html="postItem.content.replace(/\n/g,'<br>')" @click='contentClick'></div>-->
<!--                <div v-if="postItem.refPost" style="margin-top: 10px">-->
<!--                    <div v-html="refContent(postItem.refPost)" @click="refContentClick"></div>-->
<!--                </div>-->

<!--                <div v-if="postItem.lastEditTime" style="font-size:12px;margin-right: 5px;color: #969799;text-align: right" >-->
<!--                    已在{{moment(postItem.lastEditTime).fromNow()}}编辑过-->
<!--                </div>-->

<!--                <div style="text-align: right">-->

<!--                    <van-button v-if="postItem.editable" @click="$emit('showEdit',postItem)"-->
<!--                                plain type="default" size="small" round icon="edit"-->
<!--                                style="margin-right: 5px">-->
<!--                    </van-button>-->
<!--                    <van-button v-if="postItem.deletable" @click="delPost"-->
<!--                                plain type="default" size="small" round icon="delete"-->
<!--                                style="margin-right: 5px">-->
<!--                    </van-button>-->

<!--                    <van-button plain type="default" size="small" round icon="comment-o"-->
<!--                                style="margin-right: 5px"-->
<!--                                @click="addPost">-->
<!--                        {{postItem.postCount}}-->
<!--                    </van-button>-->

<!--                    <van-button plain type="default" size="small" round icon="good-job-o"-->
<!--                                :class="postItem.iagree?'agree':''"-->
<!--                                @click="setAgree">{{postItem.agreeCount}}-->
<!--                    </van-button>-->
<!--                </div> -->
<!--            </div>-->

<!--        </van-cell>-->

    </div>
</template>

<script>
    import NickAndAvatar from "../components/nickAndAvatar";
    import Nick from "../components/nick"
    export default {
        name: 'post',
        components:{NickAndAvatar,Nick},
        props: ["pid","total","index"],
        data: function () {
            return {
                postItem: {
                    uid: '',
                    ctime:'',
                    tid: '',
                    pid: '',
                    content: '',
                    agreeCount: 0,
                    postCount: 0,
                    iagree: false,
                    refPid: '',
                    refPost:{
                        pid:''
                    }
                },
            }
        },
        watch:{
          pid:function(newVal,oldVal){
              if( (!oldVal) && newVal) {
                  this.getPost();
              }
          }
        },
        methods: {
            floor:function(){
                var f= this.index;
              if(f==0){
                  return "沙发"
              }
              else if(f==1){
                  return "板凳"
              }
              else if (f==2){
                  return "地板"
              }
              else{
                  return f+1 +'楼'
              }
            },
            refContent:function(post){

                var src = post.content;

                if(src) {
                    var reg = /<img src="(.*?)" style="max-width: 80%">/g;

                    var ret = src.replace(reg,function(result,url,index,src){
                        // console.log(result,url);
                        return "<a href='javascript:void(0)' id='"+url+"'>[图片]</a>";
                    });

                    return  ret;
                }
                else {
                    return '-----'
                }
            },
            refContentClick:function(event){
                console.log(event);
                if(event.srcElement.tagName=='A') {
                    this.$emit("contentClick", {
                        srcElement: {
                            tagName: "IMG",
                            src: event.srcElement.id
                        }
                    })
                }
            },
            contentClick:function(event){
                this.$emit("contentClick",event)
            },
            checkLogin:function(){
                var app = this;
                console.log("检查登录");
                if(!app.$cookie.get("session")){
                    if(window.JSInterface) {
                        window.JSInterface.callMethod('login', null);
                    }
                    return false;
                }
                return true;
            },
            getPost: function () {
                var app = this;
                app.axios.post("/getPost", {
                    uid: 1,
                    pid: app.pid
                }).then(function (res) {
                    if (res.data.errcode == "suc") {
                        app.postItem = res.data.data;
                    }
                })
            },
            delPost: function () {
                var app = this;
                if(!app.checkLogin()){
                    return;
                }
                app.axios.post("/delPost", {
                    pid: app.pid
                })
                    .then(function (res) {
                        console.log("delPost",res.data.errcode)
                        if (res.data.errcode == 'suc') {

                            app.$emit('deleted')
                        }
                    })
            },
            addPost: function () {
                this.$emit("addPost")
            },
            setAgree: function () {
                var app = this;
                if(!app.checkLogin()){
                    return;
                }
                var pid = app.postItem.pid;
                app.axios.post("/setAgree", {
                    pid: pid,
                    agree: app.postItem.iagree ? "cancel" : "agree"
                })
                    .then(function (res) {
                        if (res.data.errcode == 'suc') {
                            app.getPost();
                        }
                    });
            },
        },
        mounted:function(){
            this.getPost();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
